@if (institutionId > 0) {
  <div id="submodule-public-note" class="cw-module-card">
    <!-- Header -->
    <div class="cw-flex-row">
      <!-- Modul-Titel -->
      <h2>{{ 'GENERAL.NOTES' | translate }}</h2>
      <!-- Toolbar -->
      @if (!editMode) {
        <phscw-toolbar
          componentIdentifier="institutions-public-note"
          [componentConnection]="$any(this)"
          [buttonEditmode]="true"
          printContent="submodule-public-note">
        </phscw-toolbar>
      }
    </div>
    <!-- Formular (für EditMode) -->
    @if (true) {
      <form #institutionsPublicNoteForm="ngForm" (ngSubmit)="clickSubmit()">
        <!-- IDs -->
        <input type="hidden" name="id" [(ngModel)]="noteId" />
        <input type="hidden" name="institution_id" [(ngModel)]="institutionId" />
        <!-- Eingabefelder -->
        @if (true) {
          <phscw-input-textarea
            [editMode]="editMode"
            [required]="false"
            name="note"
            inputId="note"
            [(ngModel)]="publicNote"
            [markdownRender]="contactsAndNotesMarkdownEnabled || markdownRender"
            [disabled]="false">
          </phscw-input-textarea>
        }
        <!-- Buttons Submit & Cancel (für EditMode) -->
        @if (editMode) {
          <div class="cw-button-wrapper">
            <button
              mat-raised-button
              color="accent"
              type="submit"
              [disabled]="loading || saving">
              {{ 'GENERAL.SAVE' | translate }} <span [ngClass]="saving ? 'icon-spinner icon-spin' : ''"></span>
            </button>
            <button mat-raised-button color="primary" type="button" (click)="clickCancel()">
              {{ 'GENERAL.CANCEL' | translate }}
            </button>
          </div>
        }
      </form>
    }
    <!-- Ausgabefeld ReadonlyNote -->
    @if (readOnlyNote) {
      <phscw-input-textarea
        [editMode]="false"
        label="{{ 'GENERAL.READONLYNOTE' | translate }}"
        [required]="false"
        name="note"
        inputId="note"
        [(ngModel)]="readOnlyNote"
        [disabled]="false">
      </phscw-input-textarea>
    }
  </div>
}
